require('./accountLastMovements.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @utilities
const { saveDateFilter } = require('utilities/currentAccountsHelper.js');

// @components
const AccountLastMovementsFilter = require('components/accounts/accountLastMovements/accountLastMovementsFilter/accountLastMovementsFilter');
const AccountLastMovementsContent = require('components/accounts/accountLastMovements/accountLastMovementsContent/accountLastMovementsContent');

// @constants
const { EURO_TEXT } = require('../../../constants');

class AccountLastMovements extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            filterSettingsOpen: false
        }

        this.handleToggleFilters = this.handleToggleFilters.bind(this);
        this.requestMovements = this.requestMovements.bind(this);
        this.handleRetry = this.handleRetry.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.setFilter = this.setFilter.bind(this);
        this.resetFilter = this.resetFilter.bind(this);
    }

    componentDidMount() {
        this.requestMovements();
    }

    componentWillUnmount() {
        this.clearFilters();
    }

    setFilter(filters) {
        const { setFilter } = this.props;
        setFilter(filters);
        this.requestMovements();
        saveDateFilter();
    }

    clearFilters() {
        const { clearFilters } = this.props;
        clearFilters();
        this.requestMovements();
    }

    handleRetry() {
        this.requestMovements();
    }

    handleToggleFilters() {
        this.setState({
            filterSettingsOpen: !this.state.filterSettingsOpen
        });
    }

    requestMovements() {
        const { accountId, requestAccountTransactions } = this.props;
        requestAccountTransactions(accountId);
    }

    resetFilter(filter) {
        const { resetFilter } = this.props;
        resetFilter(filter);
        this.requestMovements();
    }

    render() {
        const {
            accountId,
            downloadAccountsTransactions,
            resetScaForAccountTransactionsDownload,
            flagBasedFeatures,
            immAccountTransactionsDownload,
            immAccountsTransactions,
            immProfile,
            immSignaturePatternVirtualOffices,
            isCredit,
            isInactiveAccount,
            requestAccountTransactions,
            requestNextAccountTransactionsPage,
            toggleAccountMovementsScaModal,
            validateAndExecuteSagas,
        } = this.props;
        const { filterSettingsOpen } = this.state;
        
        const immFilter = immAccountsTransactions.get('filters');
        const immAccountTransactions = immAccountsTransactions.get(accountId);
        
        let modal = null;
        if (filterSettingsOpen) {
            const anyMovement = immAccountsTransactions.get(accountId).get('byId').first();
            const accountCurrency = anyMovement ? anyMovement.get('balance').get('currency') : null;
            modal = (
                <AccountLastMovementsFilter
                    accountId={accountId}
                    accountCurrency={accountCurrency || EURO_TEXT}
                    setFilter={this.setFilter}
                    immFilter={immFilter}
                    onCloseClick={this.handleToggleFilters}
                    isCredit={isCredit}
                    immProfile={immProfile}
                    immTransactions={immAccountTransactions}
                    toggleAccountMovementsScaModal={toggleAccountMovementsScaModal}
                    flagBasedFeatures={flagBasedFeatures}
                />
            )
        }

        let innerComponent = null
        if (!!immAccountTransactions) {
            innerComponent = (
                <AccountLastMovementsContent
                    accountId={accountId}
                    clearFilters={this.clearFilters}
                    defaultLanguage={immProfile.get('originCountry').toLowerCase()}
                    downloadAccountsTransactions={downloadAccountsTransactions}
                    resetScaForAccountTransactionsDownload={resetScaForAccountTransactionsDownload}
                    flagBasedFeatures={flagBasedFeatures}
                    immAccountTransactionsDownload={immAccountTransactionsDownload}
                    immFilter={immFilter}
                    immProfile={immProfile}
                    immSignaturePatternVirtualOffices={immSignaturePatternVirtualOffices}
                    immTransactions={immAccountTransactions}
                    isInactiveAccount={isInactiveAccount}
                    onFilterClick={this.handleToggleFilters}
                    onHandleRetry={this.handleRetry}
                    requestAccountTransactions={requestAccountTransactions}
                    requestNextAccountTransactionsPage={requestNextAccountTransactionsPage}
                    resetFilter={this.resetFilter}
                    toggleAccountMovementsScaModal={toggleAccountMovementsScaModal}
                    validateAndExecuteSagas={validateAndExecuteSagas}
                />
            );    
        }
        
        return (
            <div className="account-last-movements">
                {modal}
                {innerComponent}
            </div>
        )
    }
}

AccountLastMovements.propTypes = {
    accountId: PropTypes.string,
    clearFilters: PropTypes.func.isRequired,
    downloadAccountsTransactions: PropTypes.func.isRequired,
    resetScaForAccountTransactionsDownload: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object,
    immAccountTransactionsDownload: PropTypes.object.isRequired,
    immAccountsTransactions: PropTypes.object,
    immProfile: PropTypes.object.isRequired,
    immSignaturePatternVirtualOffices: PropTypes.object.isRequired,
    isCredit: PropTypes.bool,
    isInactiveAccount: PropTypes.bool,
    requestAccountTransactions: PropTypes.func.isRequired,
    requestNextAccountTransactionsPage: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired,
    setFilter: PropTypes.func.isRequired,
    toggleAccountMovementsScaModal: PropTypes.func.isRequired,
    validateAndExecuteSagas: PropTypes.func.isRequired,
};

AccountLastMovements.defaultProps = {
    isCredit: false
};

module.exports = AccountLastMovements;
